export default {
  locale: {
    en: 'Englisch',
    de: 'Deutsch',
  },
  app: {
    title: 'Copa',
    motto: 'Create your tournament today!',
  },
}
